import React from 'react';
import { useFormikContext } from 'formik';
import { Input } from 'syngenta-digital-cropwise-react-ui-kit';
import FormGrid, { FormRowConfig } from 'components/FormGrid';
import { COL_SPAN_FULL } from 'components/FormGrid/constants';
import { MAX_NOTES } from '../../../Constants/planFormikData';
import { PlanWizardFormValues } from '../../../types';

const { TextArea } = Input;

const NotesSection: React.FC = () => {
  const {
    values,
    errors,
    touched,
    setFieldValue,
    setFieldTouched
  } = useFormikContext<PlanWizardFormValues>();

  const currentNotesLength = (values.notes || '').length;
  const isOverLimit = currentNotesLength > MAX_NOTES;
  const notesCountColor = isOverLimit ? '#CF3537' : '#696F88';

  const notesRows: FormRowConfig[] = [
    {
      id: 'notes-row',
      fields: [
        {
          id: 'notes',
          colSpan: COL_SPAN_FULL,
          render: () => (
            <div>
              <TextArea
                name="notes"
                value={values.notes}
                onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
                  setFieldValue('notes', e.target.value)
                }
                onBlur={() => setFieldTouched('notes', true)}
                rows={6}
                status={
                  (touched.notes && errors.notes) || isOverLimit
                    ? 'error'
                    : undefined
                }
                style={{ width: '100%', resize: 'none', minHeight: '200px' }}
                autoSize={false}
                aria-label="Plan notes"
              />
              <div
                className="text-right text-xs"
                style={{
                  fontSize: '12px',
                  fontWeight: 400,
                  color: notesCountColor,
                  marginTop: '4px'
                }}
              >
                {currentNotesLength.toLocaleString()} /{' '}
                {MAX_NOTES.toLocaleString()} characters
              </div>
            </div>
          )
        }
      ]
    }
  ];

  return <FormGrid rows={notesRows} showErrorLineConditionally />;
};

export default NotesSection;
